import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetPaymentProviders } from "../../api-clients/walletsFiatChannelsClient";

function usePaymentProvidersQuery() {
  const query = useQuery({
    queryKey: [QUERY_KEYS.WALLET.PAYMENT_PROVIDERS],
    queryFn: handleGetPaymentProviders,
  });

  return {
    query,
    paymentProviders: query.data,
  };
}

export default usePaymentProvidersQuery;
